import { c as _c } from "react/compiler-runtime";
import { APIList } from '../../../../../../../../../typings/API.interface';
import { APIAccountCliKey } from '../../../../../../../../../typings/CliClient.interface';
import { formatDate } from '../../../../../../utils/date';
import Badge from '../../../../../common/base/Badge';
import Button from '../../../../../common/base/Button';
import { StyledCard, StyledCardSection } from '../../../../../common/base/Card';
import Loading from '../../../../../common/base/Loading';
import Text from '../../../../../common/base/Text';
import { Div } from '../../../../../common/helpers/StyledUtils';
import { useDatePreferences } from '../../../../../hooks/useDatePreferences';
import { CliCommand, getDeviceName } from './utils';
interface SessionsSectionProps {
  cli_keys?: APIList<APIAccountCliKey>;
  has_error: boolean;
  page_limit: number;
  onRevoke: (cli_id: string, device_name: string) => void;
  onRevokeAll: () => void;
}
const SessionsSection: React.FC<SessionsSectionProps> = t0 => {
  const $ = _c(11);
  const {
    cli_keys,
    has_error,
    page_limit,
    onRevoke,
    onRevokeAll
  } = t0;
  const {
    timezone
  } = useDatePreferences();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      b: 10
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Text bold={true} size="l" as="h2" m={{
      t: 0,
      b: 1
    }}>Sessions</Text>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      t: 0,
      b: 4
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Text muted={true} m={t3}>Each <CliCommand>hookdeck login</CliCommand> creates a session for that device. Revoke any you don't recognize or no longer use.</Text>;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== cli_keys || $[5] !== has_error || $[6] !== onRevoke || $[7] !== onRevokeAll || $[8] !== page_limit || $[9] !== timezone) {
    t5 = <Div m={t1}>{t2}{t4}{has_error && !cli_keys ? <Text danger={true}>Your sessions could not be loaded, please refresh the page.</Text> : <Loading require={[cli_keys]}>{() => <StyledCard separator={true} overflow_hidden={true}>{cli_keys.models.length === 0 && <StyledCardSection p={{
            x: 4,
            y: 3
          }}><Text muted={true}>No sessions yet. Run <CliCommand>hookdeck login</CliCommand> to create one.</Text></StyledCardSection>}{cli_keys.models.map(cli_key => <StyledCardSection key={cli_key.id} data-testid="session-row" flex={{
            align: "center",
            justify: "space-between",
            gap: 4
          }} p={{
            x: 4,
            y: 3
          }}><Div><Div flex={{
                align: "center",
                gap: 2
              }}><Text semi={true} size="s">{getDeviceName(cli_key.device_name)}</Text>{cli_key.is_listening && <Badge subtle={true} success={true}>Active now</Badge>}</Div><Text size="s" muted={true}>Created {formatDate(cli_key.created_at, "MMM d, yyyy, h:mm a", timezone)}</Text></Div><Button outline={true} danger={true} icon="delete" onClick={() => onRevoke(cli_key.id, cli_key.device_name)}>Revoke</Button></StyledCardSection>)}{cli_keys.pagination.next && <StyledCardSection p={{
            x: 4,
            y: 3
          }}><Text size="s" muted={true}>Showing your {page_limit} newest sessions. Revoke all also logs out the older ones.</Text></StyledCardSection>}{cli_keys.models.length > 0 && <StyledCardSection muted={true} flex={{
            align: "center",
            justify: "space-between",
            gap: 4
          }} p={{
            x: 4,
            y: 3
          }}><Text>Log out every CLI that uses your account</Text><Button outline={true} danger={true} icon="logout" onClick={onRevokeAll}>Revoke all</Button></StyledCardSection>}</StyledCard>}</Loading>}</Div>;
    $[4] = cli_keys;
    $[5] = has_error;
    $[6] = onRevoke;
    $[7] = onRevokeAll;
    $[8] = page_limit;
    $[9] = timezone;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};
export default SessionsSection;